import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import { schoolGradingScale } from '@careerstart/wae-common/src/main/helperFunction/schoolGradingScale';

import launchDarklyToggles, {
  DARKLY_TOGGLE_NAMES,
} from '../../main-deprecated/utils/launchDarklyToggles';
import selectUser from '../store/selectors/appSelector';

const useFairReliabilityScore = () => {
  const flags = useFlags();
  const currentUser = useSelector(selectUser);
  const isFairReliabilityScoreOn = launchDarklyToggles(
    flags,
    DARKLY_TOGGLE_NAMES.hb5599SwitchToFairReliabilityScore
  );

  // rawReliability is shown on a school grading scale (0-1 -> 0.6-1); the legacy score is shown as-is.
  const pickReliability = (raw, legacy) =>
    isFairReliabilityScoreOn ? schoolGradingScale(raw) : legacy;

  return {
    isFairReliabilityScoreOn,
    pickReliability,
    canSeeAls: isFairReliabilityScoreOn && currentUser?.role === UserRole.ADMIN,
  };
};

export default useFairReliabilityScore;
